import CheckboxField from 'components/forms/checkboxField/CheckboxField';
import FormWithProvider from 'components/forms/form/Form';
import {
  AgencySettings,
  CustomIntegrationSettingsType,
  Integration,
  IntegrationEnum,
} from 'models/InternalIntegrationSetting';
import { useTranslation } from 'react-i18next';
import useReadOnlyAccessMutation, {
  ReadOnlyAccessAction,
} from './useReadOnlyAccessMutation';

const DataReadAccessCheckbox = ({
  agencySettings: { customIntegrationSettings },
  integration: { enumId, displayName, name },
}: {
  agencySettings: AgencySettings;
  integration: Integration;
}) => {
  const { t } = useTranslation();

  const { mutate: toggleReadOnlyAccess, isLoading: isMutatingReadOnlyAccess } =
    useReadOnlyAccessMutation();

  const isReadDataAccessNeeded = [
    IntegrationEnum.BEYONDPRICING,
    IntegrationEnum.PRICELABS,
    IntegrationEnum.QUIBBLE,
    IntegrationEnum.WHEELHOUSE,
  ].includes(enumId);

  if (!isReadDataAccessNeeded) {
    return null;
  }

  const integrationName = displayName ?? name;

  const getInitialValues = () => {
    switch (customIntegrationSettings?.type) {
      case CustomIntegrationSettingsType.READ_ONLY_ACCESS_SETTINGS:
        return {
          enableReadOnlyAccessForAllProperties:
            customIntegrationSettings.enableReadOnlyAccessForAllProperties,
        };

      default:
        return {
          enableReadOnlyAccessForAllProperties: false,
        };
    }
  };

  return (
    <FormWithProvider
      defaultValues={getInitialValues()}
      // the request dispatch is handled by the onChangeHandler, since we don't have a submit button
      onSubmit={() => {}}
    >
      <CheckboxField
        name="enableReadOnlyAccessForAllProperties"
        disabled={isMutatingReadOnlyAccess}
        data-testid="read-only-access-checkbox"
        onChangeHandler={(e) => {
          const { checked } = e.target as HTMLInputElement;

          toggleReadOnlyAccess({
            enumId,
            action: checked
              ? ReadOnlyAccessAction.ENABLE
              : ReadOnlyAccessAction.DISABLE,
          });
        }}
      >
        {t('pageIntegrations.integrationDetails.grantDataReadAccess', {
          integration: integrationName,
        })}
      </CheckboxField>
    </FormWithProvider>
  );
};

export default DataReadAccessCheckbox;
